/**
 * Identidade visual das personas (cor + nome curto), indexada pelo id de agente.
 * DEVE bater com AGENT_DEFS (useAgentRunState.ts) e com _PERSONA_CHAT_IDENTITY
 * (backend team.py). Usado para dar a cada agente sua cor/avatar no chat, na lista
 * de participantes e nos cursores — a mesma identidade em toda a UI.
 */
export interface AgentIdentity {
  personaId: string
  name: string
  color: string
}

export const AGENT_IDENTITIES: Record<string, AgentIdentity> = {
  'agent-001': { personaId: 'archie', name: 'Archie', color: '#8b5cf6' },
  'agent-002': { personaId: 'dochie', name: 'Dochie', color: '#10b981' },
  'agent-003': { personaId: 'jobs', name: 'Jobs', color: '#f59e0b' },
  'agent-004': { personaId: 'vangogh', name: 'Van Gogh', color: '#f43f5e' },
}

/** Remetente das mensagens de coordenação do Studio (plano do time). Fora de AGENT_IDENTITIES: não é persona. */
export const TEAM_IDENTITY: AgentIdentity & { id: string } = {
  id: 'agent-team',
  personaId: 'team',
  name: 'Time de especialistas',
  color: '#6d3ae0',
}

/**
 * Resolve a identidade de um agente por id (agent-00N) ou, em fallback, pelo nome
 * exibido (ex.: "Archie (Arquiteto de Soluções)").
 */
export function resolveAgentIdentity(
  senderId?: string,
  senderName?: string,
): AgentIdentity | null {
  if (senderId && AGENT_IDENTITIES[senderId]) return AGENT_IDENTITIES[senderId]
  if (senderId === TEAM_IDENTITY.id) return TEAM_IDENTITY
  if (senderName) {
    const lower = senderName.toLowerCase()
    for (const identity of Object.values(AGENT_IDENTITIES)) {
      if (lower.includes(identity.name.toLowerCase())) return identity
    }
  }
  return null
}
